import {inject} from "@angular/core";
import {ConfigService} from "../../services/config.service";
import {Payment} from "../../../data/models/payment.model";

export class OnlinePaymentChecker {
  public readonly ONLINE_PAYMENT_METHOD_ID_CONFIG_KEY: string = 'paymentprovider.paypal.paymentcode';
  private onlinePaymentMethodId: string = '';

  constructor() {}

  setPaymentCode(onlinePaymentMethodId: string) {
    this.onlinePaymentMethodId = onlinePaymentMethodId;
  }

  isOnlinePayment(payment: Payment): boolean {
    return payment?.paymentType?.paymentMethod === this.onlinePaymentMethodId;
  }
}
